import moment from 'moment';

export class ApiCourseRegistrationUpdate {
    registration_pk: number;

    constructor(data) {
        if (data.id) this.registration_pk = data.id;
    }
}
